<template>
  <div
    class="country-cards"
  >
    <template v-if="!loading && !error">
      <CountryCardItem
        v-for="country in countries"
        :key="country.alpha3Code"
        :country="country"
      />
    </template>
    <template v-else-if="error">
      {{ error }}
    </template>
    <template v-else-if="loading">
      <CardItemSkeleton
        v-for="(card, idx) of 8"
        :key="idx"
      />
    </template>
  </div>
</template>

<script>
import CountryCardItem from '@/components/CountriesCardItem.vue';
import CardItemSkeleton from '@/components/CardItemSkeleton.vue';

export default {
  components: {
    CountryCardItem,
    CardItemSkeleton,
  },
  props: {
    countries: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
      default: true,
    },
    error: {
      type: null,
      required: true,
    },
  },
  setup() {
  },
};
</script>

<style lang="sass">
.country-cards
  display: flex
  justify-content: space-between
  align-content: center
  align-items: center
  flex-flow: row wrap
  gap: 2.5rem
  margin-top: clamp(2rem, 5vw, 3rem)
  > *
    margin: 0 auto

</style>
